import {
  TInProgressDetails,
  TRoamingQcDB,
  TRoamingQcEventWithoutStatus,
  TRoamingQcStore,
  TRoamingQcStoreLockedBy,
  TTransactionGroupedAudits,
} from '@monorepo/types';
import { Action } from '@ngrx/store';

export enum RoamingQcStoreActionTypes {
  AcquireLockAndThenInitStore = 'AcquireLockAndThenInitStore',
  InitStoreAndThenReleaseLock = 'InitStoreAndThenReleaseLock',
  UpdateStoreAndReleaseLock = 'UpdateStoreAndReleaseLock',
  UpdateStoreAndReleaseLockAndThenGoToInspection = 'UpdateStoreAndReleaseLockAndThenGoToInspection',
  UpdateRoamingQcStoreLockDetails = 'UpdateRoamingQcStoreLockDetails',
  AcquireLockAndUpdateInProgressDetails = 'AcquireLockAndUpdateInProgressDetails',
  AcquireLockAndClearInProgressDetails = 'AcquireLockAndClearInProgressDetails',
  AcquireLockAndClearTransactionLogRecords = 'AcquireLockAndClearTransactionLogRecords',
  ClearTransactionLogRecordsAndReleaseLock = 'ClearTransactionLogRecordsAndReleaseLock',
  AcquireLockAndFetchTransactionLogRecords = 'AcquireLockAndFetchTransactionLogRecords',
  FetchAndUpdateTransactionLogRecordsAndReleaseLock = 'FetchAndUpdateTransactionLogRecordsAndReleaseLock',
  UpdateTransactionLogRecordsAndReleaseLock = 'UpdateTransactionLogRecordsAndReleaseLock',
  UpdateInitialRoundInfoAndReleaseLock = 'UpdateInitialRoundInfoAndReleaseLock',
  UpdateInProgressDetailsAndReleaseLock = 'UpdateInProgressDetailsAndReleaseLock',
  ClearInProgressDetailsAndReleaseLock = 'ClearInProgressDetailsAndReleaseLock',
  AcquireLockAndUpdateEpfDetailsAndRecentCategoryList = 'AcquireLockAndUpdateEpfDetailsAndRecentCategoryList',
  UpdateEpfDetailsAndRecentCategoryListAndReleaseLock = 'UpdateEpfDetailsAndRecentCategoryListAndReleaseLock',
  RoamingQcNoAction = 'RoamingQcNoAction',
  ReleaseRoamingQcLock = 'ReleaseRoamingQcLock',
}

export class AcquireLockAndThenInitStore implements Action {
  readonly type = RoamingQcStoreActionTypes.AcquireLockAndThenInitStore;
  constructor(public lockFor: TRoamingQcStoreLockedBy) {}
}

export class InitStoreAndThenReleaseLock implements Action {
  readonly type = RoamingQcStoreActionTypes.InitStoreAndThenReleaseLock;
  constructor(public initBy: TRoamingQcStoreLockedBy) {}
}

export class UpdateStoreAndReleaseLock implements Action {
  readonly type = RoamingQcStoreActionTypes.UpdateStoreAndReleaseLock;
  constructor(public roamingQcDB: TRoamingQcDB) {}
}

export class UpdateStoreAndReleaseLockAndThenGoToInspection implements Action {
  readonly type = RoamingQcStoreActionTypes.UpdateStoreAndReleaseLockAndThenGoToInspection;
  constructor(public roamingQcDB: TRoamingQcDB) {}
}

export class UpdateRoamingQcStoreLockDetails implements Action {
  readonly type = RoamingQcStoreActionTypes.UpdateRoamingQcStoreLockDetails;
  constructor(public lockDetails: TRoamingQcStore['lockDetails']) {}
}

export class RoamingQcNoAction implements Action {
  readonly type = RoamingQcStoreActionTypes.RoamingQcNoAction;
  constructor() {}
}

export class ReleaseRoamingQcLock implements Action {
  readonly type = RoamingQcStoreActionTypes.ReleaseRoamingQcLock;
  constructor() {}
}

export class AcquireLockAndUpdateEpfDetailsAndRecentCategoryList implements Action {
  readonly type = RoamingQcStoreActionTypes.AcquireLockAndUpdateEpfDetailsAndRecentCategoryList;
  constructor(public bulkEvent: TRoamingQcEventWithoutStatus, public toBeRemovedModals: number) {}
}

export class UpdateEpfDetailsAndRecentCategoryListAndReleaseLock implements Action {
  readonly type = RoamingQcStoreActionTypes.UpdateEpfDetailsAndRecentCategoryListAndReleaseLock;
  constructor(
    public roamingQcDB: TRoamingQcDB,
    public bulkEvent: TRoamingQcEventWithoutStatus,
    public toBeRemovedModals: number,
  ) {}
}

export class AcquireLockAndUpdateInProgressDetails implements Action {
  readonly type = RoamingQcStoreActionTypes.AcquireLockAndUpdateInProgressDetails;
  constructor(
    public inProgressDetails: TInProgressDetails,
    public toBeRemovedModals: number,
    public chainWithEventAddition?: TRoamingQcEventWithoutStatus,
  ) {}
}

export class UpdateInProgressDetailsAndReleaseLock implements Action {
  readonly type = RoamingQcStoreActionTypes.UpdateInProgressDetailsAndReleaseLock;
  constructor(
    public roamingQcDB: TRoamingQcDB,
    public toBeRemovedModals: number,
    public chainWithEventAddition?: TRoamingQcEventWithoutStatus,
  ) {}
}

export class AcquireLockAndClearInProgressDetails implements Action {
  readonly type = RoamingQcStoreActionTypes.AcquireLockAndClearInProgressDetails;
  constructor(public toBeRemovedModals: number) {}
}

export class ClearInProgressDetailsAndReleaseLock implements Action {
  readonly type = RoamingQcStoreActionTypes.ClearInProgressDetailsAndReleaseLock;
  constructor(public roamingQcDB: TRoamingQcDB, public toBeRemovedModals: number) {}
}

export class AcquireLockAndFetchTransactionLogRecords implements Action {
  readonly type = RoamingQcStoreActionTypes.AcquireLockAndFetchTransactionLogRecords;
  constructor(
    public startTime: number,
    public endTime: number,
    public updateInitialRoundInfo?: { defaultToEmptyTransactionsInCaseOfError: boolean },
  ) {}
}

export class FetchAndUpdateTransactionLogRecordsAndReleaseLock implements Action {
  readonly type = RoamingQcStoreActionTypes.FetchAndUpdateTransactionLogRecordsAndReleaseLock;
  constructor(
    public startTime: number,
    public endTime: number,
    public updateInitialRoundInfo?: { defaultToEmptyTransactionsInCaseOfError: boolean },
  ) {}
}

export class UpdateTransactionLogRecordsAndReleaseLock implements Action {
  readonly type = RoamingQcStoreActionTypes.UpdateTransactionLogRecordsAndReleaseLock;
  constructor(public transactions: TTransactionGroupedAudits[]) {}
}

export class UpdateInitialRoundInfoAndReleaseLock implements Action {
  readonly type = RoamingQcStoreActionTypes.UpdateInitialRoundInfoAndReleaseLock;
  constructor(public transactions: TTransactionGroupedAudits[]) {}
}

export class AcquireLockAndClearTransactionLogRecords implements Action {
  readonly type = RoamingQcStoreActionTypes.AcquireLockAndClearTransactionLogRecords;
  constructor() {}
}

export class ClearTransactionLogRecordsAndReleaseLock implements Action {
  readonly type = RoamingQcStoreActionTypes.ClearTransactionLogRecordsAndReleaseLock;
  constructor() {}
}

export type TRoamingQcStoreActions =
  | UpdateStoreAndReleaseLock
  | UpdateRoamingQcStoreLockDetails
  | UpdateInProgressDetailsAndReleaseLock
  | ClearInProgressDetailsAndReleaseLock
  | ReleaseRoamingQcLock
  | ClearTransactionLogRecordsAndReleaseLock
  | UpdateInitialRoundInfoAndReleaseLock
  | UpdateTransactionLogRecordsAndReleaseLock
  | UpdateStoreAndReleaseLockAndThenGoToInspection
  | UpdateEpfDetailsAndRecentCategoryListAndReleaseLock;
